var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 487.744 487.744",
    style: {
      enableBackground: "new 0 0 487.744 487.744"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5230E"
    },
    d: "M243.864,248.016c37.608,0,70.168-20.656,86.376,19.328c6.968-17.168,10.968-36.64,10.968-57.328 c0-68.856-43.576-124.672-97.344-124.672c-53.752,0-97.328,55.816-97.328,124.672c0,20.688,4,40.16,10.968,57.328 C173.704,227.36,206.272,248.016,243.864,248.016z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F76F6F"
    },
    points: "444.336,352.936 290.904,305.704 290.904,292.184 196.848,292.184 196.848,305.704  43.408,352.936 51.408,487.744 52.568,487.448 52.568,487.744 433.32,487.744 433.32,486.984 436.336,487.744 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E54E4E"
    },
    points: "444.336,352.936 290.904,305.704 290.904,292.184 196.848,292.184 196.848,305.704  43.408,352.936 115.432,487.744 116.584,487.448 52.568,487.744 433.32,487.744 433.32,486.984 436.336,487.744 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5230E"
    },
    d: "M348.536,152c0,35.344-51.264,64-104.672,64c-53.376,0-104.656-28.656-104.656-64 s51.28-64,104.656-64C297.272,88,348.536,116.656,348.536,152z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.832,
    y: 194.184,
    style: {
      fill: "#F9BDA0"
    },
    width: 94.056,
    height: 116.56
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "290.904,298.688 290.904,202.184 196.848,202.184 244.6,354.264 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M318.832,120.656c0,72.248-36.624,137.624-74.944,137.624s-74.96-65.376-74.96-137.624 c0-72.232,36.64-84.28,74.96-84.28S318.832,48.416,318.832,120.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M243.888,36.368c38.32,0,74.944,12.048,74.944,84.28c0,72.248-36.624,137.624-74.944,137.624"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3401E"
    },
    d: "M254.304,31.608c0,0-69.656,53.328,89.92,117.576c0,0,3.064-70.688-23-101.504 c-26.08-30.8-66.44-27-66.44-27L254.304,31.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F36"
    },
    d: "M279.256,22.496c0,0,64.16,71.112-135.672,132.048c0,0-11.784-75.968,18.984-108.528 c30.76-32.544,85.92-27.144,85.92-27.144L279.256,22.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3401E"
    },
    d: "M248.488,18.872l30.768,3.624c0,0,64.16,71.112-135.672,132.048"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA78C"
    },
    d: "M290.904,305.704v-13.512h-94.056v13.512l-40.512,12.472c5.544,28.048,42.576,49.736,87.536,49.736 s82-21.688,87.536-49.736L290.904,305.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M252.664,443.464l-5.28-2.344c-3.784,8.784,2.168,19.872,10.936,23.752l1.44-3.264 C253.912,457.576,251.112,450.36,252.664,443.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M259.992,465.728l1.376-3.064c5.032,2.328,6.752,9.424,4.472,14.496l-1.888-0.856 C264.912,472.312,263.32,468.104,259.992,465.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M254.536,439.496l-4.288-1.184c-1.896,7.112,3.888,14.888,11.008,16.872l0.72-2.656 C257.08,450.104,254.128,444.92,254.536,439.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M262.632,455.64l0.704-2.488c4.096,1.2,6.2,6.424,5.032,10.544l-1.528-0.44 C267.112,460.104,265.432,457.072,262.632,455.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M253.24,441.744l-0.44-6.528c10.816-0.608,20.312,10.048,21.048,20.888l-4.048,0.264 C267.768,448.592,261.184,442.792,253.24,441.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M274.096,458.232l-3.8,0.28c0.528,6.264,7.424,10.856,13.72,10.408l-0.176-2.344 C279.2,466.032,275.336,462.712,274.096,458.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M256.864,439.464l-2.768-5.472c9.096-4.488,21.16,1.232,25.76,10.296l-3.384,1.72 C271.88,440.04,264.08,437.464,256.864,439.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M280.848,446.032l-3.16,1.624c2.736,5.2,10.344,6.64,15.592,3.952l-1.008-1.952 C288.096,450.888,283.552,449.432,280.848,446.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M235.072,443.464l5.288-2.344c3.784,8.784-2.168,19.872-10.936,23.752l-1.432-3.264 C233.832,457.576,236.632,450.36,235.072,443.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M227.752,465.728l-1.376-3.064c-5.032,2.328-6.752,9.424-4.472,14.496l1.888-0.856 C222.832,472.312,224.416,468.104,227.752,465.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M233.208,439.496l4.288-1.184c1.896,7.112-3.888,14.888-11.008,16.872l-0.736-2.656 C230.664,450.104,233.608,444.92,233.208,439.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M225.112,455.64l-0.704-2.488c-4.096,1.2-6.216,6.424-5.032,10.544l1.528-0.44 C220.632,460.104,222.304,457.072,225.112,455.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54E4E"
    },
    d: "M234.504,441.744l0.44-6.528c-10.824-0.608-20.312,10.048-21.048,20.888l4.048,0.264 C219.96,448.592,226.568,442.792,234.504,441.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M213.648,458.232l3.792,0.28c-0.52,6.264-7.416,10.856-13.704,10.408l0.176-2.344 C208.544,466.032,212.408,462.712,213.648,458.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54E4E"
    },
    d: "M230.88,439.464l2.768-5.472c-9.096-4.488-21.168,1.232-25.768,10.296l3.392,1.72 C215.864,440.04,223.664,437.464,230.88,439.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M206.896,446.032l3.16,1.624c-2.736,5.2-10.344,6.64-15.592,3.952l1-1.952 C199.648,450.888,204.192,449.432,206.896,446.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54E4E"
    },
    d: "M272.616,401.12c0-16.84-12.856-24.496-28.744-24.496s-28.752,7.656-28.752,24.496 c0,12.84,7.48,29.048,18.08,36.032c-0.056,0.56-0.088,1.112-0.088,1.656c0,7.424,4.672,10.816,10.408,10.816 c5.752,0,10.408-3.392,10.408-10.816c0-0.408-0.016-0.816-0.048-1.232C264.832,430.856,272.616,414.232,272.616,401.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3838"
    },
    d: "M233.2,437.152c-0.056,0.56-0.088,1.112-0.088,1.656c0,7.424,4.672,10.816,10.408,10.816 c5.752,0,10.408-3.392,10.408-10.816c0-0.408-0.016-0.816-0.048-1.232c10.952-6.72,18.736-23.344,18.736-36.456 c0-16.84-12.856-24.496-28.744-24.496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76F6F"
    },
    d: "M264.128,410.296c0-11.872-9.064-17.264-20.256-17.264c-11.184,0-20.256,5.392-20.256,17.264 c0,9.048,5.28,20.472,12.736,25.392c-0.032,0.392-0.048,0.784-0.048,1.16c0,5.232,3.28,7.624,7.328,7.624s7.328-2.392,7.328-7.624 c0-0.28-0.016-0.56-0.032-0.856C258.632,431.248,264.128,419.528,264.128,410.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA6565"
    },
    d: "M241.024,393.152c-9.832,0.856-17.408,6.296-17.408,17.144c0,9.048,5.28,20.472,12.736,25.392 c-0.032,0.392-0.048,0.784-0.048,1.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 237.872,
    cy: 421.232,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 249.84,
    cy: 421.232,
    r: 1.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#19DAF4"
    },
    cx: 204.752,
    cy: 421.952,
    r: 3.392
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#19DAF4"
    },
    cx: 206.384,
    cy: 397.472,
    r: 3.392
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6AE6EF"
    },
    cx: 209.848,
    cy: 416.272,
    r: 1.832
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6AE6EF"
    },
    cx: 216.12,
    cy: 427.776,
    r: 0.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0CB0C6"
    },
    cx: 210.184,
    cy: 431.792,
    r: 2.104
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0CB0C6"
    },
    cx: 208.216,
    cy: 410.592,
    r: 0.952
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0CB0C6"
    },
    cx: 212.032,
    cy: 423.632,
    r: 0.296
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60656D"
    },
    d: "M189.648,246.672c-23.528,0-42.672-19.144-42.672-42.672V8c0-4.424,3.576-8,8-8s8,3.576,8,8v196 c0,14.704,11.96,26.672,26.672,26.672c4.416,0,8,3.576,8,8S194.056,246.672,189.648,246.672z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.976,
    y: 12.672,
    style: {
      fill: "#F4750C"
    },
    width: 16,
    height: 14.656
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#DB4A09"
    },
    points: "146.976,27.328 162.976,27.328 162.976,12.672 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.976,
    y: 34.92,
    style: {
      fill: "#F4750C"
    },
    width: 16,
    height: 14.656
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#DB4A09"
    },
    points: "146.976,49.576 162.976,49.576 162.976,34.92 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.976,
    y: 57.168,
    style: {
      fill: "#F4750C"
    },
    width: 16,
    height: 14.656
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#DB4A09"
    },
    points: "146.976,71.824 162.976,71.824 162.976,57.168 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434851"
    },
    d: "M189.648,230.672c-14.712,0-26.672-11.968-26.672-26.672V8c0-3.936-2.904-7.064-6.656-7.72v230.032 c7.816,9.888,19.768,16.36,33.328,16.36c4.416,0,8-3.576,8-8S194.056,230.672,189.648,230.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434851"
    },
    d: "M211.648,249.312c-0.328,0.032-0.656,0.112-1,0.112c-7.32,0-13.248-5.936-13.248-13.248 c0-7.328,5.928-13.248,13.248-13.248c0.344,0,0.672,0.08,1,0.096v-13.248c-0.344-0.016-0.656-0.096-1-0.096 c-14.64,0-26.496,11.856-26.496,26.496s11.856,26.496,26.496,26.496c0.344,0,0.656-0.096,1-0.112V249.312z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#17AD17"
    },
    d: "M153.648,155.672c0-25.952,40.736-31,91-31c50.248,0,91,5.048,91,31s-40.752,47-91,47 C194.376,202.672,153.648,181.624,153.648,155.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E960E"
    },
    d: "M244.648,124.672c50.248,0,91,5.048,91,31s-40.752,47-91,47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2AD32A"
    },
    d: "M244.648,128.344c49.032,0,88.888,4.856,90.816,29.2c0.048-0.624,0.184-1.248,0.184-1.872 c0-25.952-40.752-31-91-31c-50.264,0-91,5.048-91,31c0,0.624,0.144,1.248,0.184,1.872C155.744,133.2,195.6,128.344,244.648,128.344z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7CD3DD"
    },
    d: "M173.144,158.856c0-15.64,32-18.688,71.504-18.688c39.496,0,71.504,3.048,71.504,18.688 c0,15.624-32.008,28.312-71.504,28.312C205.144,187.168,173.144,174.48,173.144,158.856z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABF0F4"
    },
    d: "M273.776,140.984l-45.416,45.424c5.232,0.488,10.672,0.768,16.28,0.768 c1.416,0,2.8-0.048,4.184-0.096l43.888-43.888C287.128,142.168,280.768,141.448,273.776,140.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABF0F4"
    },
    d: "M252.352,140.216c-2.528-0.032-5.096-0.048-7.704-0.048c-7.344,0-14.44,0.112-21.096,0.376 l-35.544,35.544c5.752,2.952,12.92,5.456,21.144,7.312L252.352,140.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ABF0F4"
    },
    d: "M295.68,143.76l-43.232,43.232c35.832-1.544,63.704-13.56,63.704-28.144 C316.144,151.136,308.336,146.496,295.68,143.76z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4750C"
    },
    d: "M170.976,163.104c0,2.64-2.144,4.784-4.784,4.784h-23.44c-2.64,0-4.784-2.144-4.784-4.784v-9.872 c0-2.64,2.144-4.784,4.784-4.784h23.44c2.64,0,4.784,2.144,4.784,4.784V163.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB4A09"
    },
    d: "M166.192,148.448h-5.856c-0.76,6.84-7.296,12.216-15.36,12.216c-2.528,0-4.888-0.576-7-1.512v3.952 c0,2.64,2.144,4.784,4.784,4.784h23.44c2.64,0,4.784-2.144,4.784-4.784v-9.872C170.976,150.592,168.832,148.448,166.192,148.448z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434851"
    },
    d: "M146.976,162.672c0,0.832-0.672,1.504-1.504,1.504l0,0c-0.832,0-1.504-0.672-1.504-1.504v-9 c0-0.832,0.672-1.504,1.504-1.504l0,0c0.832,0,1.504,0.672,1.504,1.504V162.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434851"
    },
    d: "M152.976,162.672c0,0.832-0.672,1.504-1.504,1.504l0,0c-0.832,0-1.504-0.672-1.504-1.504v-9 c0-0.832,0.672-1.504,1.504-1.504l0,0c0.832,0,1.504,0.672,1.504,1.504V162.672z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4750C"
    },
    d: "M318.32,153.232c0-2.64,2.144-4.784,4.784-4.784h23.44c2.64,0,4.784,2.144,4.784,4.784v9.872 c0,2.64-2.144,4.784-4.784,4.784h-23.44c-2.64,0-4.784-2.144-4.784-4.784V153.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB4A09"
    },
    d: "M323.096,167.888h5.856c0.752-6.84,7.296-12.216,15.36-12.216c2.528,0,4.888,0.576,7,1.512v-3.952 c0-2.64-2.144-4.784-4.784-4.784h-23.44c-2.64,0-4.784,2.144-4.784,4.784v9.872C318.32,165.744,320.456,167.888,323.096,167.888z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434851"
    },
    d: "M342.32,153.672c0-0.832,0.672-1.504,1.504-1.504l0,0c0.832,0,1.504,0.672,1.504,1.504v9 c0,0.832-0.672,1.504-1.504,1.504l0,0c-0.832,0-1.504-0.672-1.504-1.504V153.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434851"
    },
    d: "M336.32,153.672c0-0.832,0.672-1.504,1.504-1.504l0,0c0.832,0,1.504,0.672,1.504,1.504v9 c0,0.832-0.672,1.504-1.504,1.504l0,0c-0.832,0-1.504-0.672-1.504-1.504V153.672z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4750C"
    },
    d: "M265.32,197.376c0,7.232-12.832,17.296-21.592,17.296c-8.752,0-21.576-10.064-21.576-17.296 c0-7.216,12.832-29.92,21.576-29.92C252.488,167.448,265.32,190.152,265.32,197.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB4A09"
    },
    d: "M243.72,167.448c8.768,0,21.592,22.704,21.592,29.92c0,7.232-12.832,17.296-21.592,17.296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC8D3A"
    },
    d: "M243.72,171.704c7.936,0,19.168,18.592,21.232,27.472c0.16-0.608,0.36-1.216,0.36-1.8 c0-7.216-12.832-29.92-21.592-29.92c-8.752,0-21.576,22.704-21.576,29.92c0,0.576,0.2,1.184,0.36,1.8 C224.568,190.296,235.8,171.704,243.72,171.704z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiver);
export default __webpack_public_path__ + "static/media/diver.d33e878c4e107b698098c11c0b3249af.svg";
export { ForwardRef as ReactComponent };